export default __webpack_public_path__ + "media/color/xmy-b653e3ac.svg";